// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import configuration from "../../utils/Config";
import { createEffect } from "effector";
import { restListHandler } from "../../utils/rest/RestClient";
import { MissingUserListResponseDto } from "../../api/backend-openapi";

const baseUrl = configuration.backendBaseUrl;
const missingUserUrl = baseUrl + "/missingUsers/";
export const missingUserExportUrl = missingUserUrl + "export";

export const requestGetMissingUsers = createEffect({
  handler: restListHandler<MissingUserListResponseDto>(missingUserUrl)
});
